import {Component, OnInit} from '@angular/core';
import {IShopUser} from "../../../session/customer-models";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {BaseComponent} from "../../../base.component";
import {TranslateService} from "../../../translation/translate.service";
import {CustomerUtil} from "../../../util/customer-util";

@Component({
    selector: 'landing-ad-hero-guided', // this is being used by CMS Placeholder Module. Do not change.
    templateUrl: './landing-ad-hero-guided.component.html',
    standalone: false
})
export class LandingAdHeroGuidedComponent extends BaseComponent implements OnInit {

    customerId: string;
    firstName: string;
    titleText: string;
    messageText: string;
    useLocaleOverride: boolean;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private translateService: TranslateService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.getCustomerData().then((user: IShopUser) => {
            this.customerId = this.authenticated ? user.customer.id.toString() : '';
            this.firstName = CustomerUtil.getDisplayFirstName(this.authenticated, user);
            this.getTranslations();
        });
    }

    getTranslations(): void {
        this.translateService.translateRequest({
            tag: 'cart.hero.ad.guided.enrollment.welcome',
            replacements: new Map([['firstName', this.firstName]])
        }, this.useLocaleOverride).then(res => this.titleText = res);

        this.translateService.translateRequest({
            tag: 'cart.landing.ad.guided.hero.enrollment.message',
            replacements: new Map([['customerId', this.customerId]])
        }, this.useLocaleOverride).then(res => this.messageText = res);
    }
}
